import { Transforms } from 'slate'
import { useEditor, useFocused, useSelected } from 'slate-react'
import React from 'react'

import BlockPlugin from './BlockPlugin'
import DropdownWithInput from '../../../kiti/components/form/DropdownWithInput'
import Tag from '../../../kiti/components/presentation/Tag'

const COMPLEX_INTERPOLATION_TYPES = ['images_interpolation']
const INTERPOLATION_TYPES = ['interpolation', ...COMPLEX_INTERPOLATION_TYPES]

const Element = ({ children, attributes, element, ...props }) => {
  const selected = useSelected()
  const focused = useFocused()

  return (
    <div {...attributes} contentEditable={false} style={{ display: 'inline-block' }}>
      {children}
      <Tag label={element.name} color="light2" borderColor={selected && focused && 'lightBlue'} />
    </div>
  )
}

const insertInterpolationOnContent = (editor, name, code, nodeType = 'interpolation') => {
  const text = { text: code }
  const node = { type: nodeType, name, children: [text] }
  Transforms.insertNodes(editor, node)
  Transforms.move(editor)
}

const InterpolationsDropdown = ({ options }) => {
  const editor = useEditor()
  if (!options || !options.length) return false

  if (!editor.fullInterpolationControl) {
    options = options.filter(option => !COMPLEX_INTERPOLATION_TYPES.includes(option.nodeType))
  }

  return (
    <DropdownWithInput
      label="Campos dinâmicos"
      options={options}
      bold={false}
      size="xsmall"
      color="dark4"
      position="right"
      dropdownWidth={18}
      onChange={({ name, id, nodeType }) => insertInterpolationOnContent(editor, name, id, nodeType)}
    />
  )
}

const extend = options => editor => {
  const { fullControl } = options || {}
  const { isInline, isVoid, markableVoid } = editor

  editor.fullInterpolationControl = fullControl

  editor.isInline = element => {
    return INTERPOLATION_TYPES.includes(element.type) ? true : isInline(element)
  }

  editor.isVoid = element => {
    return INTERPOLATION_TYPES.includes(element.type) ? true : isVoid(element)
  }

  editor.markableVoid = element => {
    return INTERPOLATION_TYPES.includes(element.type) || markableVoid(element)
  }

  return editor
}

const InterpolationPlugin = {
  ...BlockPlugin,
  Dropdown: InterpolationsDropdown,
  Element,
  extend
}

export default InterpolationPlugin
